<template>
  <v-form ref="form">
    <v-card v-if="users">
      <v-card-title>
        {{ $t("referenceableByForm.title") }}
      </v-card-title>

      <v-card-text>
        <v-autocomplete
          v-model="referenceableBy"
          :items="items"
          :label="$t('referenceableByForm.users.label')"
          multiple
          clearable
        ></v-autocomplete>
      </v-card-text>

      <v-card-actions>
        <v-btn color="primary" class="mr-4" @click="save" :loading="loading" :disabled="!changed">
          {{ $t("referenceableByForm.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="saved" color="secondary">
      <div class="text-center flex-grow-1">
        {{ $t("action.saved") }}
      </div>
    </v-snackbar>
  </v-form>
</template>

<script>
import { map, pluck, symmetricDifference } from "ramda";
import UpdateUserMutation from "@/gql/mutations/UpdateUserMutation.gql";
import AdminUsersQuery from "@/gql/queries/AdminUsers.gql";

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      referenceableBy: pluck("id", this.user.referenceableBy),
      users: null,
      loading: false,
      saved: false,
    };
  },

  apollo: {
    users: {
      query: AdminUsersQuery,
    },
  },

  computed: {
    items() {
      return map(
        (user) => ({
          value: user.id,
          text: user.company.address.name,
        }),
        this.users
      );
    },

    changed() {
      return symmetricDifference(this.referenceableBy, pluck("id", this.user.referenceableBy)).length > 0;
    },
  },

  methods: {
    async save() {
      this.loading = true;

      await this.$apollo.mutate({
        mutation: UpdateUserMutation,
        variables: {
          id: this.user.id,
          input: {
            referenceableBy: this.referenceableBy,
          },
        },
      });

      this.loading = false;
      this.saved = true;
    },
  },
};
</script>
